import React from "react";

interface AgentLogoProps {
    gradient?: boolean;
}

export function AgentLogo({
    gradient = false,
    ...props
}: Omit<React.ComponentPropsWithoutRef<"svg">, "xmlns" | "viewBox"> &
    AgentLogoProps) {
    const baseId = React.useId().replace(/:/g, "");
    const clipPathId = `${baseId}-agent-logo-clip`;
    const maskId = `${baseId}-agent-logo-mask`;
    const paintId = (index: number) => `${baseId}-agent-logo-paint-${index}`;
    const logoFill = (index: number) =>
        gradient ? `url(#${paintId(index)})` : "currentColor";

    return (
        <svg
            height="27px"
            width="27px"
            fill="none"
            {...props}
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath={`url(#${clipPathId})`}>
                <mask
                    id={maskId}
                    color={props.color}
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="-12"
                    y="-5"
                    width="87"
                    height="80"
                >
                    <path
                        d="M-12 38.9987L26.5916 -4.94568L32.9403 0.629742L-5.65124 44.5741L-12 38.9987Z"
                        fill={logoFill(0)}
                    />
                    <path
                        d="M-0.814096 48.8221L9.43068 37.1563C10.8237 35.5701 13.2388 35.4135 14.8249 36.8065C16.4111 38.1994 16.5678 40.6145 15.1748 42.2007L4.93002 53.8665L-0.814096 48.8221Z"
                        fill={logoFill(1)}
                    />
                    <path
                        d="M9.76716 58.1144L27.1803 38.286C28.5733 36.6998 30.9884 36.5432 32.5746 37.9361C34.1608 39.3291 34.3174 41.7442 32.9244 43.3304L15.5113 63.1589L9.76716 58.1144Z"
                        fill={logoFill(2)}
                    />
                    <path
                        d="M20.3484 67.4068L31.3897 54.8341C32.7827 53.2479 35.1978 53.0912 36.784 54.4842C38.3701 55.8772 38.5268 58.2923 37.1338 59.8785L26.0925 72.4512L20.3484 67.4068Z"
                        fill={logoFill(3)}
                    />
                    <path
                        d="M37.4527 69.2714L48.3429 56.8707C49.7358 55.2845 52.1509 55.1279 53.7371 56.5209C55.3233 57.9138 55.4799 60.3289 54.087 61.9151L43.1968 74.3158L37.4527 69.2714Z"
                        fill={logoFill(4)}
                    />
                    <path
                        d="M19.0729 31.9693C17.4867 30.5763 17.3301 28.1612 18.723 26.575L43.2437 -1.34674L48.9878 3.69768L24.4672 31.6195C23.0742 33.2057 20.6591 33.3623 19.0729 31.9693Z"
                        fill={logoFill(5)}
                    />
                    <path
                        d="M36.8225 33.099C35.2363 31.706 35.0797 29.2909 36.4727 27.7047L54.5538 7.1157L60.2979 12.1601L42.2168 32.7491C40.8238 34.3353 38.4087 34.492 36.8225 33.099Z"
                        fill={logoFill(6)}
                    />
                    <path
                        d="M57.9851 51.6837C56.3989 50.2907 56.2422 47.8756 57.6352 46.2894L68.428 33.9997L74.1721 39.0441L63.3793 51.3339C61.9864 52.9201 59.5713 53.0767 57.9851 51.6837Z"
                        fill={logoFill(7)}
                    />
                    <path
                        d="M41.0319 49.6471C39.4457 48.2541 39.2891 45.839 40.6821 44.2528L65.135 16.4081L70.8792 21.4525L46.4262 49.2972C45.0332 50.8834 42.6181 51.0401 41.0319 49.6471Z"
                        fill={logoFill(8)}
                    />
                </mask>
                <g mask={`url(#${maskId})`} color={props.color}>
                    <path
                        d="M56.5384 10.3334C70.0599 22.2078 71.3951 42.7952 59.5207 56.3167C47.6463 69.8381 27.0589 71.1733 13.5374 59.2989C0.015981 47.4245 -1.31921 26.8371 10.5552 13.3157C22.4296 -0.205776 43.017 -1.54096 56.5384 10.3334Z"
                        fill={logoFill(9)}
                    />
                </g>
            </g>
            <defs>
                {gradient && (
                    <>
                    <linearGradient
                        id={paintId(0)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(1)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(2)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(3)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(4)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(5)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(6)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(7)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(8)}
                        x1="-8.74727"
                        y1="39.176"
                        x2="81.7552"
                        y2="29.2112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    <linearGradient
                        id={paintId(9)}
                        x1="-7.73401"
                        y1="38.0461"
                        x2="80.7274"
                        y2="26.225"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#32D1B7" />
                        <stop offset="0.695" stopColor="#349BC7" />
                        <stop offset="1.0001" stopColor="#3664D6" />
                    </linearGradient>
                    </>
                )}
                <clipPath id={clipPathId}>
                    <rect width="70" height="70" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
